// extracted by mini-css-extract-plugin
module.exports = {"background":"NotFoundPage_background__3jj93","title":"NotFoundPage_title__QfVb-","description":"NotFoundPage_description__ca2bL","actions":"NotFoundPage_actions__2_thR"};